module.exports = __webpack_public_path__ + "static/media/Logotipo_NSA.f7451fdf.png";